export const getResortedTiles = <T>(array: T[], windowWidth: number): T[] => {
    const resortedTiles: T[] = [];
    // Если меньше или равно 500px, то возвращаем без пересортировки
    if (windowWidth <= 500) {
        return array;
    }
    /* преобразование массива для вывода в 3 столбца
        |1|4|7|    |1|2|6|
        |2|5| | => |4|5| |
        |3|6| |    |7|3| |
    */
    if (windowWidth > 1119) {
        [1, 2, 3].forEach((_index, idx) => {
            for (var i = idx; i < array.length; i += 3) {
                resortedTiles.push(array[i]);
            }
        });
    } else {
        /* преобразование массива для вывода в 2 столбца
            |1|4|    |1|2|
            |2|5| => |3|4|
            |3| |    |5| |
        */
        [1, 2].forEach((_index, idx) => {
            for (var i = idx; i < array.length; i += 2) {
                resortedTiles.push(array[i]);
            }
        });
    }
    return resortedTiles;
};
